<template>
<section class="question p-number ">
    <div class="">
        <div class="container">
            <div class="row ">
                <div class="col-12">
                    <div class="title">
                        <label>{{$res('site.question.label')}}</label>
                        <span>{{$res('site.question.label')}}</span>
                    </div>
                    <div class="accordion accordion-flush">
                        <div class="accordion-item p-number"
                             v-for="(item, index) in data"
                             :key="index">
                            <h2 class="accordion-header p-number" :id="`flush-headingOne_${index}`">
                                <button class="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        :data-bs-target="`#flush-collapseOne_${index}`"
                                        :aria-controls="`flush-collapseOne_${index}`">
                                    {{ item.question }}
                                </button>
                            </h2>
                            <div :id="`flush-collapseOne_${index}`"
                                 class="accordion-collapse collapse"
                                 :aria-labelledby="`flush-headingOne_${index}`">
                                <div class="accordion-body">{{ item.answer }}</div>
                            </div>
                        </div>
                    </div>
                <router-link to="/page/faq" class="btn-question mt-5">ادامه سوالات</router-link>

                </div>
            </div>
        </div>
    </div>
</section>
</template>
<script>

    export default {
     props:{
         data:{
             type:Array
         }
     }
    };
</script>

<style scoped>
    .question {
        width: 100%;
        min-height: 300px;
        padding-bottom: 10px;

    }

    .title label,
    .title span {
        text-align: center;
        width: 100%;
        height: 70px;
    }

    .title label {
        font-size: 30px;
        margin: 0;
        color: #ebc75d;
        z-index: 1;
        position: relative;
    }

    .title span {
        font-size: 50px;
        opacity: 0.5;
        color: #f1f1f1;
        margin-top: -80px;
        z-index: 0;
        display: block;
    }
  
 .btn-question {
  background-color: #ebc75d;
  border: 1px solid #ebc75d;
  color: white;
  width: 150px;
  height: 50px;
  transition: all 0.5s;
  float: left;
  text-align: center;
  text-decoration: none;
  position: relative;
  padding-top: 15px;
}

.btn-question::before,
 .btn-question::after {
  content: "";
  position: absolute;
  background: #ebc75d;
  transition: all 0.5s;
}

.btn-question::before {
  top: 10px;
  left: -5px;
  width: 1px;
  height: 100%;
}

 .btn-question::after {
  bottom: -5px;
  right: 10px;
  width: 100%;
  height: 1px;
}

.btn-question:hover::before {
  height: 0;
}

.btn-question:hover::after {
  width: 0;
}

.btn-question:hover {
  background-color: white;
  color: black;
  border: 1px solid #ebc75d;
}

</style>